// extracted by mini-css-extract-plugin
module.exports = {"head":"Table_head__3u2-E","col":"Table_col__3JU7y"};